// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EgUSvg {
  position: relative;
}

.ta3Zye {
  position: relative;
  display: none;
  width: 0;
  height: 0;
}

.CqfrUK {
  font-size: 20px;
  line-height: 26px;
  text-align: left;
  width: 100%;
}

.eHUNfm {
  font-size: 15px;
  line-height: 21px;
  text-align: left;
  width: 80%;
}

.dwP_NO {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  row-gap: 0;
  flex-wrap: wrap;

  & > div {
    flex: 1 1 0;
  }

  .DCtdsw {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 4px;
    margin-top: 4px;
    flex: 1 1 100%;

    & > p {
      margin-bottom: 0;
    }
  }
}

.ihDuHp {
  width: 100%;
}

.hMmXrc {
  width: 100%;
}

.HTzvvZ {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 14px;
}

.uDLJpE {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  padding: 12px 20px;
  border: 1px solid var(--ibk-colors-neutral-400, #d9d9d9);
  border-radius: var(--ibk-radius-s, 4px);
}

.J6DAfL {
  flex: 1;
  height: 16px;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  vertical-align: middle;
}

.FsGlIi {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.nc7owI {
  position: fixed;
}

.GHPA9U {
  position: absolute;
  left: 50%;
  transform: translateX(-57%);
}

.GHPA9U.VXtx6n {
  top: 100%;
}

.GHPA9U.ewzlz0 {
  bottom: 100%;
}

.lwLL8F {
  position: relative;
  width: min(272px, calc(100vw - 16px));
  max-width: 272px;
  padding: 24px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  height: auto;
  box-sizing: border-box;
}

.VXtx6n .lwLL8F::before {
  content: '';
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 12px solid #e6e6e6;
}

.VXtx6n .lwLL8F::after {
  content: '';
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-bottom: 11px solid #ffffff;
}

.ewzlz0 .lwLL8F::before {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 12px solid #e6e6e6;
}

.ewzlz0 .lwLL8F::after {
  content: '';
  position: absolute;
  bottom: -11px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 13px solid transparent;
  border-right: 13px solid transparent;
  border-top: 11px solid #ffffff;
}

.UWuHKo {
  margin: 0 12px;
}

.tftGhq {
  display: grid;
  grid-template-columns: 24px 0.5fr 24px;
  align-items: center;
  margin-bottom: 16px;
  height: 40px;
  justify-content: center;
}

.WjFEvp {
  font-family: var(--ibk-typography-fontFamilyBase, 'Source Sans 3');
  font-weight: var(--ibk-typography-fontWeightSemiBold, 600);
  font-style: normal;
  font-size: var(--ibk-typography-fontSizeSm, 12px);
  line-height: 100%;
  letter-spacing: 0;
  color: var(--ibk-colors-primary-orange-500, #d64000);
  text-align: center;
}

.n62bHq {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  margin-bottom: 8px;
  height: 24px;
}

.n62bHq > div {
  font-family: var(--font-family-base, 'Source Sans 3');
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--type-paragraph-md-font-size, 12px);
  color: var(--text-neutral-dark, #1f1f1f);
  line-height: 100%;
}

.K1UBGa {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.KUjL67 {
  width: 28px;
  height: 28px;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
}

.SJpNbR {
  color: var(--text-neutral-silver-gray, #cccccc);
}

.ixLavJ {
  opacity: 0.3;
  cursor: not-allowed;
}

.TCZwtj {
  background: var(--primary-orange-500, #d64000);
  color: white;
}

.XIt97U {
  background: var(--ibk-colors-primary-orange-200, #ffeee5);
}

.HWSOVY,
.Y8TDVf {
  background: var(--primary-orange-500, #d64000);
  color: var(--text-neutral-white);
}

.G61siB {
  border: none;
  background: transparent;
  color: var(--primary-orange-500, #d64000);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

._3shDXD {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: auto;
}

.BEcoxe {
  height: 24px;
  padding-right: var(--spacing-1-5);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--ibk-typography-fontSizeSm, 12px);
  cursor: pointer;
}

.QFIUEi {
  height: 16px;
  width: 16px;
}

.Nojunp {
  background: none;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0;
  margin: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cQbiai {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
}

.ENd9mO {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Calendar/Calendar.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;;EAEf;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;IACR,eAAe;IACf,cAAc;;IAEd;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wDAAwD;EACxD,uCAAuC;AACzC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kEAAkE;EAClE,0DAA0D;EAC1D,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;EACjB,iBAAiB;EACjB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,mDAAmD;EACnD,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;;EAEE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".popper {\n  position: relative;\n}\n\n.hidePopper {\n  position: relative;\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n.title {\n  font-size: 20px;\n  line-height: 26px;\n  text-align: left;\n  width: 100%;\n}\n\n.description {\n  font-size: 15px;\n  line-height: 21px;\n  text-align: left;\n  width: 80%;\n}\n\n.fields {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 16px;\n  row-gap: 0;\n  flex-wrap: wrap;\n\n  & > div {\n    flex: 1 1 0;\n  }\n\n  .messageContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 4px;\n    margin-top: 4px;\n    flex: 1 1 100%;\n\n    & > p {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.singleField {\n  width: 100%;\n}\n\n.periodField {\n  width: 100%;\n}\n\n.label {\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 14px;\n}\n\n.textInputAndSvg {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  width: 100%;\n  padding: 12px 20px;\n  border: 1px solid var(--ibk-colors-neutral-400, #d9d9d9);\n  border-radius: var(--ibk-radius-s, 4px);\n}\n\n.textInput {\n  flex: 1;\n  height: 16px;\n  width: 100%;\n  font-size: 14px;\n  line-height: 20px;\n  vertical-align: middle;\n}\n\n.calendarContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.calendarContainerFloating {\n  position: fixed;\n}\n\n.calendarContainerInline {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-57%);\n}\n\n.calendarContainerInline.calendarContainerBottom {\n  top: 100%;\n}\n\n.calendarContainerInline.calendarContainerTop {\n  bottom: 100%;\n}\n\n.calendar {\n  position: relative;\n  width: min(272px, calc(100vw - 16px));\n  max-width: 272px;\n  padding: 24px;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  height: auto;\n  box-sizing: border-box;\n}\n\n.calendarContainerBottom .calendar::before {\n  content: '';\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 14px solid transparent;\n  border-right: 14px solid transparent;\n  border-bottom: 12px solid #e6e6e6;\n}\n\n.calendarContainerBottom .calendar::after {\n  content: '';\n  position: absolute;\n  top: -11px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n  border-bottom: 11px solid #ffffff;\n}\n\n.calendarContainerTop .calendar::before {\n  content: '';\n  position: absolute;\n  bottom: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 14px solid transparent;\n  border-right: 14px solid transparent;\n  border-top: 12px solid #e6e6e6;\n}\n\n.calendarContainerTop .calendar::after {\n  content: '';\n  position: absolute;\n  bottom: -11px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n  border-top: 11px solid #ffffff;\n}\n\n.arrow {\n  margin: 0 12px;\n}\n\n.calendarHeader {\n  display: grid;\n  grid-template-columns: 24px 0.5fr 24px;\n  align-items: center;\n  margin-bottom: 16px;\n  height: 40px;\n  justify-content: center;\n}\n\n.monthTitle {\n  font-family: var(--ibk-typography-fontFamilyBase, 'Source Sans 3');\n  font-weight: var(--ibk-typography-fontWeightSemiBold, 600);\n  font-style: normal;\n  font-size: var(--ibk-typography-fontSizeSm, 12px);\n  line-height: 100%;\n  letter-spacing: 0;\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  text-align: center;\n}\n\n.weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  margin-bottom: 8px;\n  height: 24px;\n}\n\n.weekdays > div {\n  font-family: var(--font-family-base, 'Source Sans 3');\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--type-paragraph-md-font-size, 12px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  line-height: 100%;\n}\n\n.daysGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n}\n\n.dayButton {\n  width: 28px;\n  height: 28px;\n  margin: 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  border-radius: 50%;\n  cursor: pointer;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.dayOutside {\n  color: var(--text-neutral-silver-gray, #cccccc);\n}\n\n.dayDisabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.daySelected {\n  background: var(--primary-orange-500, #d64000);\n  color: white;\n}\n\n.dayInRange {\n  background: var(--ibk-colors-primary-orange-200, #ffeee5);\n}\n\n.dayRangeStart,\n.dayRangeEnd {\n  background: var(--primary-orange-500, #d64000);\n  color: var(--text-neutral-white);\n}\n\n.arrowButton {\n  border: none;\n  background: transparent;\n  color: var(--primary-orange-500, #d64000);\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.select {\n  display: flex;\n  flex: 1;\n  justify-content: flex-end;\n  align-items: flex-end;\n  width: 100%;\n  height: auto;\n}\n\n.selectButton {\n  height: 24px;\n  padding-right: var(--spacing-1-5);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--ibk-typography-fontSizeSm, 12px);\n  cursor: pointer;\n}\n\n.calendarIcon {\n  height: 16px;\n  width: 16px;\n}\n\n.calendarIconButton {\n  background: none;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calendarFooter {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.calendarConfirmSelectButton {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popper": `EgUSvg`,
	"hidePopper": `ta3Zye`,
	"title": `CqfrUK`,
	"description": `eHUNfm`,
	"fields": `dwP_NO`,
	"messageContainer": `DCtdsw`,
	"singleField": `ihDuHp`,
	"periodField": `hMmXrc`,
	"label": `HTzvvZ`,
	"textInputAndSvg": `uDLJpE`,
	"textInput": `J6DAfL`,
	"calendarContainer": `FsGlIi`,
	"calendarContainerFloating": `nc7owI`,
	"calendarContainerInline": `GHPA9U`,
	"calendarContainerBottom": `VXtx6n`,
	"calendarContainerTop": `ewzlz0`,
	"calendar": `lwLL8F`,
	"arrow": `UWuHKo`,
	"calendarHeader": `tftGhq`,
	"monthTitle": `WjFEvp`,
	"weekdays": `n62bHq`,
	"daysGrid": `K1UBGa`,
	"dayButton": `KUjL67`,
	"dayOutside": `SJpNbR`,
	"dayDisabled": `ixLavJ`,
	"daySelected": `TCZwtj`,
	"dayInRange": `XIt97U`,
	"dayRangeStart": `HWSOVY`,
	"dayRangeEnd": `Y8TDVf`,
	"arrowButton": `G61siB`,
	"select": `_3shDXD`,
	"selectButton": `BEcoxe`,
	"calendarIcon": `QFIUEi`,
	"calendarIconButton": `Nojunp`,
	"calendarFooter": `cQbiai`,
	"calendarConfirmSelectButton": `ENd9mO`
};
module.exports = ___CSS_LOADER_EXPORT___;
